module.exports = __webpack_public_path__ + "static/media/5.24.a8550c56.png";